var _path, _path2, _path3, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQubi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    transform: "matrix(.69 0 0 .69 15.5 15.5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9 73.3c1.9-5.8 3.7-12.3 4.4-16.1-2.7-1-5.4-1.7-7.9-2.3-2.8-.7-6.9-2-9.5-3.1-.7-.3-1.3-.7-1.9-1.1-8.1-1.9-15.5-2.8-18.4-3.1-.6-.1-1.1.5-1 1.1l.7 4.7c.1.3.2.6.5.7l6.4 3.3-1.1 4.9c1.3-.3 2.6-.4 4-.4 10.7 0 19.5 8.7 19.5 19.5h7.2c-2.6-1.6-4-5-2.9-8.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7 61.9c3.8 0 7.4 1.1 10.4 3l.3-7.3c0-.8-.4-1.6-1.1-2l-14.5-7.7-6.4-11.2c-.3-.4-.7-.7-1.2-.7h-4.4c-.7-.5-1.6-.7-2.5-.6-3.1.5-6.6.8-8.2.5-.8-2.6-1.9-8.4-2.4-11.7-.2-1-1.1-1.9-1.6-2.3s-1.2-.9-2.1-1.3c-5.4-2.3-7.1-.8-11.8 4.4-4 4.5-7.6 11.5-8.7 17.3-.2.5-.3 1.1-.4 1.9-.3 2.2 1 4.1 3 5 2.2 1 6.1 2.2 9.1 3 3.2.8 6.8 1.8 10.2 3.3-.4 3.5-2.6 11.9-4.9 18.7-.7 2.1.4 4.4 2.6 5.2.6.2 1.2.2 1.7.2 1.5-.2 2.9-1.2 3.4-2.8.1-.2 1.9-5.6 3.3-11.2 2.6-9.7 3.1-14.7-.9-16.6-3.9-1.9-8-3.1-11.5-4.1 1.2-3 2.7-6.5 4.1-9.4.4 1.6.8 3 1.2 3.9.4 1 1.4 3.2 7.5 3.2 1.9 0 4.4-.2 7.4-.8.7-.1 1.2-.4 1.7-.9h2l3.9 6.8c-1.5.6-3.3 1.6-5.3 3.5-.9.9-2.9 2-5.4 3 .1 3.7-1 8-2.1 12-1.5 5.8-3.4 11.3-3.4 11.4-.5 1.6-1.6 2.9-3 3.7h10.4c.2-10.7 8.9-19.4 19.6-19.4zM18.3 65.6c-8.7 0-15.8 7.1-15.8 15.8 0 8.7 7.1 15.8 15.8 15.8C26.9 97.1 34 90 34 81.4c0-8.7-7.1-15.8-15.7-15.8zm0 21.5c-3.2 0-5.8-2.6-5.8-5.8 0-3.2 2.6-5.8 5.8-5.8s5.8 2.6 5.8 5.8c0 3.2-2.6 5.8-5.8 5.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7 65.6c-8.7 0-15.8 7.1-15.8 15.8 0 8.7 7.1 15.8 15.8 15.8 8.7 0 15.8-7.1 15.8-15.8 0-8.7-7.1-15.8-15.8-15.8zm0 21.5c-3.2 0-5.8-2.6-5.8-5.8 0-3.2 2.6-5.8 5.8-5.8 3.2 0 5.8 2.6 5.8 5.8 0 3.2-2.6 5.8-5.8 5.8z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-2.144 53.208 11.417)",
    cx: 53.2,
    cy: 11.4,
    rx: 8.5,
    ry: 8.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQubi);
export default __webpack_public_path__ + "static/media/QUBI.1654b25093f3f493fb210a5cd48ea2db.svg";
export { ForwardRef as ReactComponent };